import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { toRefs, ref, onMounted, watch, computed } from "vue";
import { useStore }                                from "vuex";
import { userHook }                                from "@/hooks/user";
import { AppFieldSelect, useFieldHook }            from "@greywind/ui";
import { FormModel as Form }                       from "@greywind/common";


export default /*#__PURE__*/_defineComponent({
  props: {
        field:      {
            type:     Object,
            required: true
        },
        error:      [ String, Boolean ],
        inputClass: String,
        modelValue: {}
    },
  emits: [ 'update:modelValue' ],
  setup(__props, { emit }) {

const props = __props


const { field, error, inputClass, modelValue } = toRefs( props );



const store            = useStore();
const { activeEnvironment } = userHook( store );
const options          = ref( [] );

const { formField, value, isReadonly } = useFieldHook(
    {
        emit, field, error, inputClass, modelValue
    }, '' );

onMounted( async (): Promise<void> => {
    const Model = new Form( 'denfield-app-user/denfield-package-forms', activeEnvironment.value.meta.api.url );
    try {
        const { data: { data } } = await Model.get( 'published' );
        if ( !data || !Array.isArray( data ) ) return;

        options.value = data.map( ( { id, name } ) => ( { label: name, value: id } ) );
    } catch ( e ) {

    }

    watch( () => value.value, v => emit( 'update:modelValue', v ) );
} );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AppFieldSelect), {
    field: {
            ..._unref(field),
            options: options.value
        },
    error: _unref(error),
    inputClass: _unref(inputClass),
    modelValue: _unref(value),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null))
  }, null, 8, ["field", "error", "inputClass", "modelValue"]))
}
}

})